import { arrayAdd, arrayRemove } from '@/helpers/array';
import { useState } from 'react';

export const useSelected = (
  initialSelected: readonly string[] | (() => readonly string[]) = []
) => {
  const [selected, setSelected] = useState(initialSelected);
  const selectedSet = new Set(selected);
  const toggleSelected = (item: string) => {
    if (selectedSet.has(item)) {
      setSelected((curSelected) => arrayRemove(curSelected, item));
    } else {
      setSelected((curSelected) => arrayAdd(curSelected, item));
    }
  };

  const isSelected = (item: string) => selectedSet.has(item);

  const resetSelected = () => setSelected([]);
  return {
    toggleSelected,
    isSelected,
    selected,
    setSelected,
    resetSelected,
    numberOfSelected: selected.length,
  };
};
